import { ErrorTodoMessages } from "@/js/constants/error-messages";
import axios from "axios";

export default {
  data: () => ({
    errorObject: undefined
  }),
  methods: {
    handleError: function(error, screenId, routeName) {
      if (this.$route.name !== routeName) {
        let params = {};
        if (error.response) {
          /**
           * Webサーバからのエラーレスポンスがある場合
           * ※APIまたはApacheが返してきたものでaxiosがエラーオブジェクトを生成して返してくる
           * */
          params = this.generateErrorMessageObject(error.response);
        } else if (error instanceof Error) {
          // 上記以外の何らかのエラーの場合（ネットワークエラー等）
          params = this.generateOtherErrorMessageObject(error);
        } else if (axios.isCancel(error)) {
          // ログイン情報がなくリクエストがキャンセルされた場合のエラー
          params = {
            cancel: { message: ErrorTodoMessages.ERWE40041 }
          };
        }
        Object.assign(params, { screenId: screenId });
        this.$router.push({
          name: routeName,
          params: params
        });
      }
    },
    handleCreateError: function(error) {
      if (error.response) {
        /**
         * Webサーバからのエラーレスポンスある場合
         * ※APIまたはApacheが返してきたものでaxiosがエラーオブジェクトを生成して返してくる
         * */
        this.errorObject = this.generateErrorMessageObject(error.response);
      } else if (error instanceof Error) {
        //  上記以外の何らかのエラーの場合（ネットワークエラー等）
        this.errorObject = this.generateOtherErrorMessageObject(error);
      }
      window.scrollTo(0, 0); // 画面のトップに移動
    },
    handleUpdateError: function(error) {
      this.handleCreateError(error);
    },
    handleGetError: function(error) {
      this.handleCreateError(error);
    },
    generateErrorMessageObject(errorResponse) {
      // APIからのエラーレスポンスの場合（APIのエラーレスポンスはJSON型、axiosでobject型に変換されて返ってくる）
      // ※APIからのエラーレスポンスの場合は、エラーメッセージ欄にステータスコード・ステータステキストは表示しない
      if (errorResponse.data && typeof errorResponse.data === "object") {
        // エラーレスポンスにdetailsが存在する場合
        if (errorResponse.data.error.message.details) {
          return {
            error: {
              code: errorResponse.data.error.code,
              message: {
                value: errorResponse.data.error.message.value,
                details: errorResponse.data.error.message.details
              }
            }
          };
        }
        // エラーレスポンスにdetailsが存在しない場合
        return {
          error: {
            code: errorResponse.data.error.code,
            message: { value: errorResponse.data.error.message.value }
          }
        };
      }
      // Apacheからのエラーレスポンス（Apacheからのエラーレスポンスは文字列）
      let errorOtherMessage = `エラーコード：${errorResponse.status}\t${errorResponse.statusText}\n${ErrorTodoMessages.ERWE40038}`;
      return { error: { message: { value: errorOtherMessage } } };
    },
    generateOtherErrorMessageObject(error) {
      // ネットワークエラーの場合
      if (error.message === "Network Error") {
        let networkErrorMessage = `エラー：${error.message}\n${ErrorTodoMessages.ERWE40038}`;
        return {
          error: { message: { value: networkErrorMessage } }
        };
      }
      // 上記以外のエラーの場合
      return {
        error: { message: { value: ErrorTodoMessages.ERWE40038 } }
      };
    }
  }
};
